import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { selectIsDesktop } from 'selectors/ui';

import Dropdown from './Dropdown';

function mapStateToProps(state, ownProps) {
  return {
    isDesktop: selectIsDesktop(state),
    ...ownProps,
  };
}

export default compose(connect(mapStateToProps), injectIntl)(Dropdown);
